import {
  selectDateOfStay,
} from '../core/reducers/date-of-stay.reducer';

/**
 * DateOfStay Selectors
 */
export { selectDateOfStay };
